class HelpUtils {
  /**
   * 根据相对路径得到完整URL
   * @param path
   */
  static getPath = (path: string): string => {
    let strUrl = path ?? '';
    if (
      strUrl.toLowerCase().indexOf('https:') !== -1 ||
      strUrl.toLowerCase().indexOf('http:') !== -1 ||
      strUrl.toLowerCase().indexOf('file:') !== -1
    ) {
      return strUrl;
    }

    const strHref = `${window.location.href.split('/')[0]}//${window.location.host}`;
    if (strUrl.indexOf('/') === 0 || strUrl.indexOf('~/') === 0) {
      strUrl = strHref + strUrl.replace('~/', '/');
    } else {
      const arrHref = window.location.pathname.split('/'); // 获取当前的相对路径级

      let intBackNum = 1;
      // 对../进行退级计算
      let strBack = '../';
      while (strUrl.indexOf(strBack) === 0) {
        // 退回上一级目录
        strBack += strBack;
        intBackNum += 1;
      }
      // 减去多余的../符
      if (intBackNum > 1) {
        strBack = strBack.replace('../', '');
      }
      strUrl = strUrl.replace(strBack, ''); // 替换退格符
      arrHref.length -= intBackNum; // 减去路径级

      const strPath = arrHref.join('/'); // 组成路径
      const strSpace = strPath.length === 0 ? '' : '/';
      strUrl = `${strHref}/${strPath}${strSpace}${strUrl}`;
    }
    return strUrl;
  };

  /**
   * 合并函数
   * @param arg
   */
  static mergeFunction = (...arg: any[]): unknown => {
    const listOfFuncs: any[] = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const func of arg) {
      listOfFuncs.push(func);
    }
    // eslint-disable-next-line func-names
    return function () {
      // eslint-disable-next-line no-restricted-syntax
      for (const func of listOfFuncs) {
        func(arg);
      }
    };
  };

  /**
   * 去掉小数末尾多余的零
   * @param old
   * @returns {string}
   */
  static cutZero = (old = ''): string => {
    // 拷贝一份 返回去掉零的新串
    let newstr = old;
    // 循环变量 小数部分长度
    const leng = old.length - old.indexOf('.') - 1;
    // 判断是否有效数
    if (old.indexOf('.') > -1) {
      // 循环小数部分
      // eslint-disable-next-line no-plusplus
      for (let i = leng; i > 0; i--) {
        // 如果newstr末尾有0
        if (newstr.lastIndexOf('0') > -1 && newstr.substr(newstr.length - 1, 1) === '0') {
          const k = newstr.lastIndexOf('0');
          // 如果小数点后只有一个0 去掉小数点
          if (newstr.charAt(k - 1) === '.') {
            return newstr.substring(0, k - 1);
          }
          // 否则 去掉一个0
          newstr = newstr.substring(0, k);
        } else {
          // 如果末尾没有0
          return newstr;
        }
      }
    }
    return old;
  };

  /**
   * 实现sleep
   * @param ms
   */
  // eslint-disable-next-line no-promise-executor-return
  static sleep = (ms: number): Promise<any> => new Promise(resolve => setTimeout(resolve, ms));

  /**
   * 格式化成标准时间格式（YYYY-MM-DD HH:mm:ss）
   * @param strDate
   * @returns {string}
   */
  static formatNormalDateString = (strDate: string): string => {
    let res = '';
    const str = HelpUtils.trim(strDate);
    if (str.indexOf(' ') > -1 && str.indexOf(':') > -1 && str.indexOf('-') > -1) {
      const date = HelpUtils.trim(str.split(' ')[0]);
      const time = HelpUtils.trim(str.split(' ')[1]);
      const year = Number(date.split('-')[0]);
      const moth =
        Number(date.split('-')[1]) < 10
          ? `0${Number(date.split('-')[1])}`
          : Number(date.split('-')[1]);
      const day =
        Number(date.split('-')[2]) < 10
          ? `0${Number(date.split('-')[2])}`
          : Number(date.split('-')[2]);
      const hour =
        Number(time.split(':')[0]) < 10
          ? `0${Number(time.split(':')[0])}`
          : Number(time.split(':')[0]);
      const minute =
        Number(time.split(':')[1]) < 10
          ? `0${Number(time.split(':')[1])}`
          : Number(time.split(':')[1]);
      const second =
        Number(time.split(':')[2]) < 10
          ? `0${Number(time.split(':')[2])}`
          : Number(time.split(':')[2]);
      res = `${year}-${moth}-${day} ${hour}:${minute}:${second}`;
    }
    return res;
  };

  /**
   * 清除首尾空格
   * @param str
   */
  static trim = (str: string): string => (str ?? '').toString().replace(/(^\s*)|(\s*$)/g, '');

  /**
   * 根据数组对象的某个字段去重
   * @param arr
   * @param key 根据哪个字段来去重
   * @returns {*[]}
   */
  static uniqueObjArr = (arr: Array<any> = [], key = ''): Array<any> => {
    const res = new Map();
    return arr.filter(item => !res.has(item[key]) && res.set(item[key], 1));
  };

  /**
   * 处理http
   * @param url 原始链接
   * @param type 不传与空为http，其余取值为https或http
   * @returns {*}
   */
  static dealHttpUrl = (url: string, type: string): string => {
    let returnStr = url;
    if (url && url !== '') {
      let isHttp = false; // 是否是正常的网址
      if (url.substr(0, 8).toLowerCase() === 'https://') {
        isHttp = true;
      }
      if (url.substr(0, 7).toLowerCase() === 'http://') {
        isHttp = true;
      }
      if (isHttp === false) {
        // 无http
        if (type && type !== '') {
          returnStr = `${type}:${returnStr}`;
        } else {
          returnStr = `http:${returnStr}`;
        }
      }
    }
    return returnStr;
  };
}

export default HelpUtils;
